// Compresses a picked image on the device before it ever leaves it: resized to
// at most 1280px on the long edge, re-encoded as JPEG starting at 72% quality
// and stepped down until it's under the target size (server/photo.js enforces a
// hard ceiling above this, as a backstop against a broken or tampered client).
const MAX_DIMENSION = 1280;
const TARGET_BYTES = 400 * 1024;
const START_QUALITY = 0.72;
const MIN_QUALITY = 0.35;

export const compressImage = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
      const width = Math.max(1, Math.round(img.width * scale));
      const height = Math.max(1, Math.round(img.height * scale));

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      let quality = START_QUALITY;
      const tryEncode = () => {
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('Could not process that image.'));
            if (blob.size <= TARGET_BYTES || quality <= MIN_QUALITY) {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(new Error('Could not process that image.'));
              reader.readAsDataURL(blob);
            } else {
              quality = Math.max(MIN_QUALITY, quality - 0.12);
              tryEncode();
            }
          },
          'image/jpeg',
          quality
        );
      };
      tryEncode();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('That file could not be read as an image.'));
    };
    img.src = url;
  });
